import { MenuItem } from '../domain/menuItem.model';

export const PROFILE_MENU: MenuItem[] = [
  { name: 'اطلاعات پایه', path: '/main/profile/basic-info', icon: 'icon-user-01' },
  { name: 'کارت‌های بانکی', path: '/main/profile/bank-cards', icon: 'icon-credit-card-02' },
  { name: 'حساب‌های متصل', path: '/main/profile/connected-accounts', icon: 'icon-phone-01' },
  { name: 'حساب کاربری', path: '/main/profile/account', icon: 'icon-shield-02' },
  { name: 'احراز هویت', path: '/main/profile/kyc', icon: 'icon-fingerprint-04' },
  { name: 'سطوح کاربری', path: '/main/profile/user-plan', icon: 'icon-users-03' },
  { name: 'تنظیمات', path: '/main/profile/setting', icon: 'icon-settings-01' },
];
